/*
 * Košík (šuplík i stránka): upozornění na kúru, doplňky k objednávce a souhlas s obchodními
 * podmínkami. Šuplík se po každé změně překreslí celý (.drawer__inner), takže všechno žije
 * v custom elementech a obnoví se v connectedCallback.
 */

if (!customElements.get('kosik-kura')) {
  /* Tlačítko „+N“ zvedne množství položky na práh kúry stejnou cestou jako stepper. */
  customElements.define(
    'kosik-kura',
    class KosikKura extends HTMLElement {
      connectedCallback() {
        const tlacitko = this.querySelector('button');
        if (!tlacitko || tlacitko.dataset.napojeno) return;
        tlacitko.dataset.napojeno = '1';
        tlacitko.addEventListener('click', () => {
          const polozky = this.closest('cart-drawer-items') || this.closest('cart-items');
          const vstup = document.getElementById(this.dataset.vstup);
          if (!polozky || !vstup) return;
          const cil = parseInt(this.dataset.cil, 10);
          // CartItems porovná výsledek s hodnotou vstupu – bez přepsání by hlásil chybu množství.
          vstup.value = cil;
          polozky.updateQuantity(this.dataset.index, cil, { currentTarget: this }, 'plus', vstup.dataset.quantityVariantId);
        });
      }
    }
  );
}

/* Text pro čtečky a zápis do živé oblasti šuplíku („Přidáno do košíku“, text z Liquidu). */
function kosikOhlas(text) {
  const oblast = document.getElementById('CartDrawer-LiveRegionText');
  if (!oblast || !text) return;
  oblast.textContent = text;
  setTimeout(() => (oblast.textContent = ''), 1500);
}

/* Překreslení šuplíku podle odpovědi Cart API (sekce šuplíku jsou v odpovědi). */
function kosikPrekresli(stav, zdroj) {
  const suplik = document.querySelector('cart-drawer');
  if (!suplik) return window.location.reload();
  suplik.classList.toggle('is-empty', stav.item_count === 0);
  suplik.renderContents(stav);
  publish(PUB_SUB_EVENTS.cartUpdate, { source: zdroj, cartData: stav });
}

/* Přidání jednoho kusu varianty z doplňku, bestselleru, dárku nebo návrhu do dopravy/dárku. Po úspěchu
   ukáže tlačítko na chvíli fajfku (návrh K5-Přidat), ohlásí „Přidáno do košíku“ a pak šuplík překreslí –
   přidaný produkt z doplňků zmizí, protože už je v košíku. */
function kosikPridej(tlacitko) {
  const varianta = tlacitko.dataset.varianta;
  if (!varianta || tlacitko.getAttribute('aria-disabled') === 'true') return;
  tlacitko.setAttribute('aria-disabled', 'true');
  tlacitko.classList.add('loading');

  const suplik = document.querySelector('cart-drawer');
  const polozka = { id: Number(varianta), quantity: 1 };
  // Dárek k nákupu: skrytá vlastnost _darek pozná řádek, který se má při ztrátě nároku odebrat (kosik-darky.liquid).
  if (tlacitko.dataset.darek) polozka.properties = { _darek: tlacitko.dataset.darek };
  const telo = { items: [polozka] };
  if (suplik) {
    telo.sections = suplik.getSectionsToRender().map((s) => s.id);
    telo.sections_url = window.location.pathname;
  }

  fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), body: JSON.stringify(telo) })
    .then((odpoved) => odpoved.json())
    .then((stav) => {
      if (stav.status) throw new Error(stav.description || stav.message);
      if (!suplik) return window.location.reload();
      tlacitko.classList.remove('loading');
      tlacitko.classList.add('je-pridano');
      kosikOhlas(document.getElementById('CartDrawer')?.dataset.textPridano);
      setTimeout(() => {
        suplik.classList.remove('is-empty');
        suplik.renderContents(stav);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kosik-doplnky', cartData: stav });
      }, 900);
    })
    .catch((chyba) => {
      console.error(chyba);
      tlacitko.removeAttribute('aria-disabled');
      tlacitko.classList.remove('loading');
    });
}

/* Odebrání slevového kódu: /cart/update.js dostane zbylé kódy (prázdný řetězec = žádný kód). */
function kosikOdeberKod(tlacitko) {
  if (tlacitko.getAttribute('aria-disabled') === 'true') return;
  tlacitko.setAttribute('aria-disabled', 'true');
  const kod = tlacitko.dataset.kod;
  const zbyle = (tlacitko.dataset.kody || '').split(',').filter((k) => k && k !== kod);
  const suplik = document.querySelector('cart-drawer');
  const telo = { discount: zbyle.join(',') };
  if (suplik) {
    telo.sections = suplik.getSectionsToRender().map((s) => s.id);
    telo.sections_url = window.location.pathname;
  }
  fetch(`${routes.cart_update_url}.js`, { ...fetchConfig(), body: JSON.stringify(telo) })
    .then((odpoved) => odpoved.json())
    .then((stav) => {
      if (stav.status) throw new Error(stav.description || stav.message);
      kosikPrekresli(stav, 'kosik-sleva');
    })
    .catch((chyba) => {
      console.error(chyba);
      tlacitko.removeAttribute('aria-disabled');
    });
}

/* Výběr varianty na kartě (volba storu kosik_varianty = vyber): „+“ ukáže varianty místo ceny, křížek je schová. */
function kosikVyberVarianty(karta, otevrit) {
  const plus = karta.querySelector('[data-vyber]');
  karta.classList.toggle('je-vyber', otevrit);
  karta.querySelector('.kosik-doplnek__varianty').hidden = !otevrit;
  plus.setAttribute('aria-expanded', String(otevrit));
  (otevrit ? karta.querySelector('.kosik-doplnek__volba') : plus).focus({ preventScroll: true });
  // Karta na okraji řady se celá posune do pohledu, ať jsou vidět ceny variant.
  if (otevrit) karta.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
}

document.addEventListener('click', (udalost) => {
  const vyber = udalost.target.closest('button[data-vyber], button.kosik-doplnek__zavrit');
  if (vyber) return kosikVyberVarianty(vyber.closest('.kosik-doplnek'), vyber.hasAttribute('data-vyber'));
  const tlacitko = udalost.target.closest('button.kosik-doplnek__pridat, button.kosik-darek__pridat, button.kosik-doplnek__volba');
  if (tlacitko) return kosikPridej(tlacitko);
  const kod = udalost.target.closest('button.kosik-sleva__odebrat');
  if (kod) kosikOdeberKod(kod);
});

if (!customElements.get('kosik-doplnky')) {
  const mezipamet = new Map();

  const nactiDoporuceni = (url, produkt, zamer) => {
    const klic = `${produkt}:${zamer}`;
    if (!mezipamet.has(klic)) {
      const adresa = `${url}?section_id=kosik-doplnky&product_id=${produkt}&limit=6&intent=${zamer}`;
      mezipamet.set(
        klic,
        fetch(adresa)
          .then((odpoved) => (odpoved.ok ? odpoved.text() : ''))
          .then((html) => [...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-doplnek]')])
          .catch(() => [])
      );
    }
    return mezipamet.get(klic);
  };

  customElements.define(
    'kosik-doplnky',
    class KosikDoplnky extends HTMLElement {
      async connectedCallback() {
        const url = this.dataset.url;
        const produkty = (this.dataset.produkty || '').split(',').filter(Boolean);
        const vKosiku = new Set((this.dataset.vKosiku || '').split(',').filter(Boolean));
        const vynechat = new Set((this.dataset.vynechat || '').split(',').filter(Boolean));
        if (!url || !produkty.length) return;
        const seznam = this.querySelector('[data-seznam]');
        // Produkty k dárku vykreslil Liquid (data-pevny) – mezi doplňky se neopakují.
        seznam.querySelectorAll('[data-pevny]').forEach((karta) => vKosiku.add(karta.dataset.produkt));

        let radky = (await Promise.all(produkty.map((p) => nactiDoporuceni(url, p, 'complementary')))).flat();
        if (!radky.length) radky = await nactiDoporuceni(url, produkty[0], 'related');

        const videne = new Set();
        radky = radky.filter((radek) => {
          const id = radek.dataset.produkt;
          if (vKosiku.has(id) || videne.has(id) || vynechat.has(radek.dataset.handle)) return false;
          videne.add(id);
          return true;
        }).map((radek) => radek.cloneNode(true)); // kopie – řádky z mezipaměti se nemění
        if (!radky.length || !this.isConnected) return;

        const cena = (r) => parseInt(r.dataset.cena, 10);
        const oznac = (radek, sablona) => {
          radek.classList.add('kosik-doplnek--navrh');
          radek.prepend(this.querySelector(sablona).content.cloneNode(true));
        };

        // Štítek „odemkne dárek“ (7. kolo): každý doplněk, který po přidání splní podmínku nejbližšího dárku –
        // u částky pokryje zbytek, u kusů chybí poslední kus; počítají se jen produkty pravidla. Jdou první, od nejlevnějšího.
        let odemknou = [];
        const darekZbyva = parseInt(this.dataset.darekZbyva, 10) || 0;
        if (this.dataset.darekTyp && darekZbyva > 0) {
          const kolekce = (this.dataset.darekKolekce || '').split(',').filter(Boolean);
          const vybrane = (this.dataset.darekProdukty || '').split(',').filter(Boolean);
          const pocita = (r) =>
            this.dataset.darekVse === 'true' ||
            vybrane.includes(r.dataset.handle) ||
            (r.dataset.kolekce || '').split(',').some((k) => kolekce.includes(k));
          const staci = (r) => (this.dataset.darekTyp === 'castka' ? cena(r) >= darekZbyva : darekZbyva === 1);
          odemknou = radky.filter((r) => r.dataset.varianta && pocita(r) && staci(r)).sort((a, b) => cena(a) - cena(b));
          odemknou.forEach((r) => oznac(r, '[data-stitek-darek]'));
        }

        // Doprava zdarma: nejlevnější doplněk bez štítku dárku, který pokryje zbytek, jde hned za ně se štítkem dopravy.
        const dopravaZbyva = parseInt(this.dataset.dopravaZbyva, 10) || 0;
        const doprava =
          dopravaZbyva > 0
            ? radky
                .filter((r) => r.dataset.varianta && !odemknou.includes(r) && cena(r) >= dopravaZbyva)
                .sort((a, b) => cena(a) - cena(b))[0]
            : null;
        if (doprava) oznac(doprava, '[data-stitek-doprava]');
        const prvni = doprava ? [...odemknou, doprava] : odemknou;
        radky = [...prvni, ...radky.filter((r) => !prvni.includes(r))];

        // Dárky a produkty k dárku vykreslil Liquid jako první karty – doplňky jdou za ně.
        seznam.querySelectorAll('[data-doplnek]:not([data-pevny])').forEach((karta) => karta.remove());
        seznam.append(...radky.slice(0, 6).map((radek) => document.importNode(radek, true)));
        this.hidden = false;
      }
    }
  );
}

if (!customElements.get('kosik-darek-odebrat')) {
  /* Dárek přidaný jako dárek, na který zmizel nárok: odebrat stejnou cestou jako koš (jinak by ho zákazník zaplatil). */
  customElements.define(
    'kosik-darek-odebrat',
    class KosikDarekOdebrat extends HTMLElement {
      connectedCallback() {
        const polozky = this.closest('cart-drawer-items') || this.closest('cart-items');
        if (!polozky || this.dataset.hotovo) return;
        this.dataset.hotovo = '1';
        customElements.whenDefined(polozky.localName).then(() => {
          if (this.isConnected) polozky.updateQuantity(this.dataset.index, 0, { currentTarget: this }, 'odebrat-darek');
        });
      }
    }
  );
}

if (!customElements.get('kosik-souhlas')) {
  const KLIC = 'ml-kosik-souhlas';

  customElements.define(
    'kosik-souhlas',
    class KosikSouhlas extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.chyba = this.querySelector('.kosik-souhlas__chyba');
        if (!this.checkbox) return;

        try {
          this.checkbox.checked = sessionStorage.getItem(KLIC) === '1';
        } catch (e) {}

        this.checkbox.addEventListener('change', () => {
          try {
            sessionStorage.setItem(KLIC, this.checkbox.checked ? '1' : '0');
          } catch (e) {}
          if (this.checkbox.checked) this.skryjChybu();
        });

        const formular = document.getElementById(this.dataset.formular);
        if (!formular || formular.dataset.souhlas) return;
        formular.dataset.souhlas = '1';
        // Vlastní chybová hláška místo bubliny prohlížeče; „required“ zůstává pro běh bez JS.
        formular.noValidate = true;
        formular.addEventListener('submit', (udalost) => {
          if (udalost.submitter && udalost.submitter.name !== 'checkout') return;
          const souhlas = document.querySelector(`kosik-souhlas[data-formular="${formular.id}"]`);
          if (souhlas && !souhlas.overeno()) udalost.preventDefault();
        });
      }

      overeno() {
        if (this.checkbox.checked) return true;
        this.checkbox.setAttribute('aria-invalid', 'true');
        this.classList.add('kosik-souhlas--chyba');
        this.chyba.hidden = false;
        this.checkbox.focus();
        this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        return false;
      }

      skryjChybu() {
        this.checkbox.removeAttribute('aria-invalid');
        this.classList.remove('kosik-souhlas--chyba');
        this.chyba.hidden = true;
      }
    }
  );
}
